export default __webpack_public_path__ + "static/media/high_sun_rays.5ad8f7ec.svg";